import http from "./httpService";

const apiUrl = http.getApiUrl();
const endPoint = "/users/";
const url = apiUrl + endPoint;

export async function getUsersCount(userType, searchQuery) {
  return await http.get(url + "count/" + userType + "?searchQuery=" + searchQuery);
}

export async function getCustomers(pageNumber, pageSize, searchQuery) {
  return await http.get(url + "customers/" + pageNumber + "/" + pageSize + "?searchQuery=" + searchQuery);
}

export async function getLeads(pageNumber, pageSize, searchQuery) {
  return await http.get(url + "leads/" + pageNumber + "/" + pageSize + "?searchQuery=" + searchQuery);
}

export async function getAdmins(pageNumber, pageSize, searchQuery) {
  return await http.get(url + "admins/" + pageNumber + "/" + pageSize + "?searchQuery=" + searchQuery);
}

export async function getUserById(customerId) {
  return await http.get(url + customerId);
}

export async function getMe() {
  return await http.get(url + "me");
}

export async function deleteUser(userId) {
  return await http.delete(url + userId);
}

export async function convertLead(userId, user) {
  return await http.put(url + "convertLead/" + userId, user);
}

export async function changePassword(passwordObject) {
  return await http.put(url + "changePassword", passwordObject);
}

export async function addUser(user) {
  return await http.post(url, user);
}

export async function updateUser(customerId, customer) {
  const payload = { ...customer };
  delete payload._id;
  delete payload.dob; //will be removed later
  return await http.put(url + customerId, payload);
}
